import { Checkbox } from "~/atoms/checkbox";
import { Label } from "~/atoms/label";

interface Props {
  id: string;
  label: string;
  checked: boolean | "indeterminate";
  disabled?: boolean;
  tooltip?: string;
  onCheckedChange: (checked: boolean) => void;
}

const CheckboxWithLabel = ({
  id,
  label,
  checked,
  disabled = false,
  tooltip,
  onCheckedChange,
}: Props) => {
  return (
    <div
      className="flex flex-row items-start space-y-0 space-x-3"
      title={tooltip}
    >
      <Checkbox
        id={id}
        className="disabled:cursor-default"
        disabled={disabled}
        checked={checked}
        onCheckedChange={(nextChecked) => onCheckedChange(nextChecked === true)}
      />
      <Label
        htmlFor={id}
        className="min-w-0 font-normal peer-disabled:cursor-default"
      >
        {label}
      </Label>
    </div>
  );
};

export default CheckboxWithLabel;
